import { CheckCircle2, Circle } from "lucide-react";
import type { ClosingChecklistItem } from "./summary/QuotationSummary.utils";

interface ClosingChecklistProps {
	items: ClosingChecklistItem[];
}

export function ClosingChecklist({ items }: ClosingChecklistProps) {
	if (items.length === 0) return null;

	return (
		<div className="rounded-lg border border-navy-600 bg-navy-800/60 p-3 space-y-2">
			<div className="text-xs font-medium text-gray-300">
				Pendencias para fechar
			</div>
			<ul className="space-y-1.5">
				{items.map((item) => (
					<li key={item.id} className="flex items-start gap-2 text-[11px] sm:text-xs">
						{item.done ? (
							<CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green-400" />
						) : (
							<Circle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gray-500" />
						)}
						<span className={item.done ? "text-green-100" : "text-gray-300"}>
							{item.label}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
}
